import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasBackToAssetClicked.meta';

export type UseTrackCanvasBackToAssetClickedParams = {
  canvas_id?: string;
  location: 'version_target_bar' | 'saved_version_toast';
};

export const useTrackCanvasBackToAssetClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasBackToAssetClicked = useCallback(
    (params: UseTrackCanvasBackToAssetClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasBackToAssetClicked };
};
